import { IAppAction } from "../appAction";
import { tagsActions } from "./tags-action";
import { getDefaultTagsState, ITagsState } from "./tags-state";

const handlers = {
  [tagsActions.FETCH_TAGS]: (
    state: ITagsState
  ): ITagsState => {
    return { ...state, loading: true };
  },

  [tagsActions.FETCH_TAGS_SUCCESS]: (
    state: ITagsState,
    tags: any
  ): ITagsState => {
    return { ...state, tags: tags, loading: false };
  },

  [tagsActions.FETCH_TAGS_ERROR]: (
    state: ITagsState,
    error: Error
  ): ITagsState => {
    return { ...state, loading: false, error: error, tags: [] };
  },
};

export const tagsReducer = (
  state: ITagsState = getDefaultTagsState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};
